/* sugar:assets/before-after-slider.js@2.2.5 */
(() => {
  if (customElements.get('before-after-slider')) return;
  // A scroll-snap row: the dots follow the slide nearest the row's start, and a dot scrolls to its slide.
  // Looping, the slides are copied once on each side and the row jumps back by one set's width whenever
  // it settles in a copy, so it never ends.
  class BeforeAfterSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-bas-track]');
      this.dots = [...this.querySelectorAll('.sugar-before-after-slider__dot')];
      this.slides = [...this.querySelectorAll('[data-bas-slide]')];
      if (!this.track || this.slides.length < 2) return;
      this.loop = this.hasAttribute('data-bas-loop');
      if (this.loop) {
        const copy = () => this.slides.map(slide => {
          const clone = slide.cloneNode(true);
          clone.removeAttribute('data-bas-slide');
          clone.removeAttribute('data-_sf');
          clone.removeAttribute('data-shopify-editor-block');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          return clone;
        });
        this.track.prepend(...copy());
        this.track.append(...copy());
        this.track.scrollLeft = this.set();
      }
      this.current = 0;
      this.onScroll = () => {
        if (this.loop) {
          clearTimeout(this.settle);
          this.settle = setTimeout(() => this.wrap(), 140);
        }
        if (this.frame || !this.dots.length) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          const max = this.track.scrollWidth - this.track.clientWidth;
          let index = 0;
          if (!this.loop && max > 0 && this.track.scrollLeft >= max - 2) {
            index = this.slides.length - 1;
          } else {
            const set = this.loop ? this.set() : 0;
            let start = this.track.scrollLeft - set;
            if (this.loop) start = ((start % set) + set) % set;
            let best = Infinity;
            this.slides.forEach((slide, i) => {
              const distance = Math.abs(slide.offsetLeft - this.slides[0].offsetLeft - start);
              if (distance < best) { best = distance; index = i; }
            });
          }
          if (index === this.current) return;
          this.dots[this.current]?.removeAttribute('aria-current');
          this.dots[index]?.setAttribute('aria-current', 'true');
          this.current = index;
        });
      };
      this.onDot = event => {
        const i = this.dots.indexOf(event.target.closest('.sugar-before-after-slider__dot'));
        if (i < 0) return;
        const left = this.slides[i].offsetLeft - this.slides[0].offsetLeft + (this.loop ? this.set() : 0);
        this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.loop) {
        this.onSettled = () => this.wrap();
        this.track.addEventListener('scrollend', this.onSettled);
      }
      this.querySelector('[data-bas-dots]')?.addEventListener('click', this.onDot);
      this.onSelect = event => {
        const slide = event.target.closest('[data-bas-slide]');
        if (slide) this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft + (this.loop ? this.set() : 0) });
      };
      if (window.Shopify?.designMode) this.addEventListener('shopify:block:select', this.onSelect);
    }
    // One set's width: from the first copy to the first real slide
    set() {
      return this.slides[0].offsetLeft - this.track.firstElementChild.offsetLeft;
    }
    wrap() {
      const set = this.set();
      if (!set) return;
      const x = this.track.scrollLeft;
      let to = x;
      if (x < set * 0.5) to = x + set;
      else if (x >= set * 1.5) to = x - set;
      if (to === x) return;
      const snap = this.track.style.scrollSnapType;
      this.track.style.scrollSnapType = 'none';
      this.track.scrollLeft = to;
      this.track.style.scrollSnapType = snap;
    }
    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.track?.removeEventListener('scrollend', this.onSettled);
      clearTimeout(this.settle);
      this.querySelector('[data-bas-dots]')?.removeEventListener('click', this.onDot);
      this.removeEventListener('shopify:block:select', this.onSelect);
    }
  }
  customElements.define('before-after-slider', BeforeAfterSlider);
})();
